import { render, staticRenderFns } from "./Cookie_policy.vue?vue&type=template&id=6f21b1da&"
import script from "./Cookie_policy.vue?vue&type=script&lang=js&"
export * from "./Cookie_policy.vue?vue&type=script&lang=js&"
import style0 from "./Cookie_policy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports